import moengage from "@moengage/web-sdk";
import { sendGTMEvent } from "@next/third-parties/google";
import { logEvent } from "firebase/analytics";
import {
  FIREBASE_EVENTS,
  getPersistentDeviceId,
  WEB_EVENTS,
} from "../constants";
import { analytics } from "../Firebase";

const sha256Hex = async (value) => {
  if (!value) return "";
  const subtle =
    typeof globalThis !== "undefined" &&
    globalThis.crypto &&
    globalThis.crypto.subtle;
  if (!subtle) return "";
  const buffer = new TextEncoder().encode(String(value));
  const digest = await subtle.digest("SHA-256", buffer);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

export const sendEventAnalytics = async ({
  eventName,
  phone = "",
  appId = "",
  customerId = "",
  sanctionedAmount,
  utm,
  skip = false,
  personalEmailId = "",
}) => {
  if (skip) return;
  const noDataEvent = [WEB_EVENTS.ON_LOGIN_SCREEN];
  const esignEvent = [WEB_EVENTS.E_SIGN_STARTED];
  const signinEvent = [WEB_EVENTS.SIGNIN_COMPLETED];
  const isNoDataEvent = noDataEvent.includes(eventName);
  const isEsignEvent = esignEvent.includes(eventName);
  const isSignInEvent = signinEvent.includes(eventName);

  const [hashedPhoneNumber, hashedEmail] = await Promise.all([
    sha256Hex(`+91${phone}`),
    sha256Hex(personalEmailId),
  ]);
  const deviceData = {
    deviceId: getPersistentDeviceId(),
    deviceType: "web",
    deviceName: `${window?.navigator?.userAgent}`,
  };
  const moengagePayload = isNoDataEvent ? {} : { phone, appId, ...deviceData };
  const firebasePayload = isNoDataEvent
    ? {}
    : {
        appId,
        custId: customerId,
        ...(isSignInEvent && { ...utm }),
        sha256_phone_number: hashedPhoneNumber,
        sha256_email_address: hashedEmail,
      };
  const otherPayload = isNoDataEvent ? {} : { appId, customerId };
  moengage.trackEvent(eventName, moengagePayload);
  logEvent(analytics, FIREBASE_EVENTS[eventName], firebasePayload);
  AF("pba", "event", {
    eventType: "EVENT",
    eventName: eventName,
    eventValue: otherPayload,
  });
  sendGTMEvent(
    {
      event: eventName,
      appId: isNoDataEvent ? "" : appId,
      auth_success: "personal loan journey",
      customerId,
      sha256_phone_number: hashedPhoneNumber,
      sha256_email_address: hashedEmail,
      ...(isEsignEvent && { sanctioned_loan_amount: sanctionedAmount }),
    },
    "gtmLayer",
  );
  fbq("trackCustom", eventName, { ...otherPayload });
};

export const sendUnserviceableEventAnalytics = ({ eventName, pin }) => {
  moengage.trackEvent(eventName, { pin });
  logEvent(analytics, eventName, { pin });
  AF("pba", "event", {
    eventName: eventName,
    eventValue: { pin },
  });
};

export const sendGTMevents = ({ appId = "", eventName, customerId = "" }) => {
  const noDataEvent = [WEB_EVENTS.ON_LOGIN_SCREEN];
  const isNoDataEvent = noDataEvent.includes(eventName);
  sendGTMEvent(
    {
      event: eventName,
      appId: isNoDataEvent ? "" : appId,
      auth_success: "personal loan journey",
      custId: customerId,
    },
    "gtmLayer",
  );
};
